import type { DocumentCallback } from "@innovatrics/dot-document-auto-capture";
import { FaceCallback } from "@innovatrics/dot-face-auto-capture/.";
import ServerSend from "./components/Server";
import AcceptTerms from "./layouts/AcceptTerms";
import Tips from "./layouts/Tips";
import TurnDoc from "./layouts/TurnDoc";
import Processing from "./layouts/Processing";
import DocumentScanFront from "./layouts/DocumentScanFront";
import DocumentScanBack from "./layouts/DocumentScanBack";
import Selfie from "./layouts/Selfie";
import SelfieFaceOnly from "./layouts/SelfieFaceOnly";
import FaceScan from "./layouts/FaceScan";
import Summary from "./layouts/Summary";
import ErrorMsg from "./layouts/ErrorMsg";
import { Languages, LangIds, getLang } from "./langs/langs";
import { Step, OnbordingData, VisitorData, VisitorDataConfig, VisitorDataConfigVal, ErrorData } from "./types";
import { useState } from "react";
import { useSearchParams } from 'react-router-dom';


const emptyOnboarding : OnbordingData = {tmp: 0, sec: 0};
const emptyError : ErrorData = {header: '', headerNum: '', msgTop: '', msgBottom: '', nextStep: Step.NONE};

const emptyVisitor : VisitorData = {id: -1, customId: '', id_lang: Languages.ENGLISH, rnd: -1,  found: false, email: '', age: 0, gender: '', givenNames: '', surname: '', fullname: '', address: '', dateOfBirth: '', personalNumber: '', citizenship: '', nationality: '', docCountry: '', docEdition: '', docType: '', docIssue: '', docExpiry: '', docNumber: '', banned: false, bannedListed: false, faceUrl: ''};
const emptyVisConfig : VisitorDataConfig = {cfgEmail: VisitorDataConfigVal.EDITABLE, cfgAge: VisitorDataConfigVal.EDITABLE, cfgGender: VisitorDataConfigVal.EDITABLE, cfgGivenNames: VisitorDataConfigVal.EDITABLE, cfgSurname: VisitorDataConfigVal.EDITABLE, cfgFullname: VisitorDataConfigVal.EDITABLE, cfgAddress: VisitorDataConfigVal.EDITABLE, cfgDateOfBirth: VisitorDataConfigVal.EDITABLE, cfgPersonalNumber: VisitorDataConfigVal.EDITABLE, cfgCitizenship: VisitorDataConfigVal.EDITABLE, cfgNationality: VisitorDataConfigVal.EDITABLE, cfgDocCountry: VisitorDataConfigVal.EDITABLE, cfgDocEdition: VisitorDataConfigVal.EDITABLE, cfgDocType: VisitorDataConfigVal.EDITABLE, cfgDocIssue: VisitorDataConfigVal.EDITABLE, cfgDocExpiry: VisitorDataConfigVal.EDITABLE, cfgDocNumber: VisitorDataConfigVal.EDITABLE };

function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlSessionId = searchParams.get('sessionId');

  const [sessionId, setSessionId] = useState<string>(urlSessionId !== null && typeof(urlSessionId) === 'string' ? urlSessionId : '');
  const [visitor, setVisitor] = useState<VisitorData>(emptyVisitor);
  const [visConfig, setVisConfig] = useState<VisitorDataConfig>(emptyVisConfig);
  const [onboarding, setOnboarding] = useState<OnbordingData>(emptyOnboarding);
  const [initSent, setInitSent] = useState<boolean>(false);

  const urlLang = searchParams.get('lang');
  if(urlLang !== null && !Number.isNaN(urlLang)){
    const lang = Number(urlLang);
    if(lang >= Languages.ENGLISH && lang < Languages.COUNT)
      visitor.id_lang = lang;
  }
  const urlEmail = searchParams.get('email');
  if(urlEmail !== null && typeof(urlEmail) === 'string'){
    visitor.email = urlEmail;
  }
  const urlCustomId = searchParams.get('customId');
  if(urlCustomId !== null && typeof(urlCustomId) === 'string'){
    visitor.customId = urlCustomId;
  }
  const urlColors = searchParams.get('colors');

  //var defStep = Step.ONBOARD_ACCEPT_TERMS;
  var defStep = Step.FACEONLY_SELFIE;
  //var defStep = Step.VISITOR_INFO;

  const [step, setStep] = useState<Step>(defStep);
  const [errorScr, setErrorScr] = useState<ErrorData>(emptyError);

  function checkStatus(obj: any) : boolean{
    if(typeof(obj.final) === 'string' && obj.final !== ''){
      window.parent.postMessage(JSON.stringify({status: obj.final}), "*");
      return true;
    }
    return false;
  }

  function postVisitor(status: string, visData: VisitorData) : void{
    window.parent.postMessage(JSON.stringify({status: status,
      visitorId: visData.id,
      customId: visData.customId,
      age: visData.age,
      gender: visData.gender,
      givenNames: visData.givenNames,
      surname: visData.surname,
      fullname: visData.fullname,
      address: visData.address,
      dateOfBirth: visData.dateOfBirth,
      personalNumber: visData.personalNumber,
      citizenship: visData.citizenship,
      nationality: visData.nationality,
      docCountry: visData.docCountry,
      docEdition: visData.docEdition,
      docType: visData.docType,
      docIssue: visData.docIssue,
      docExpiry: visData.docExpiry,
      docNumber: visData.docNumber,
      faceUrl: visData.faceUrl,
      bannedListed: visData.bannedListed,
      banned: visData.banned,}), "*");
  }

  const showError = (error: ErrorData) => {
    setErrorScr(error);
    setStep(Step.SHOW_ERROR);
  }

  const onServerFinish = () => {
  };

  const onVisitorFace: FaceCallback = async (imageData, content) => {
    setStep(Step.VISITOR_PROCESSING);
    const data = new FormData();
	  data.append("step", String(Step.VISITOR_INFO));
	  data.append("data", imageData.image);
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerVisitorRecieve, onVisitorServerFail);
  };

  const onVisitorServerFail = (msg: string, msgExt: string) => {
    showError({header: getLang(LangIds.MAIN_Selfie, visitor.id_lang), headerNum: '', msgTop: msg, msgBottom: msgExt, nextStep: Step.VISITOR_INFO});
  }

  const onVisitorError = (error: Error) => {
    showError({header: getLang(LangIds.MAIN_Selfie, visitor.id_lang), headerNum: '', msgTop: error.message, msgBottom: '', nextStep: Step.VISITOR_INFO});
  };

  const onServerVisitorRecieve = (obj: any) => {
    const id_lang = obj.found ? obj.id_lang : visitor.id_lang;
    const visData : VisitorData = {id: obj.id, customId: obj.customId, id_lang: id_lang, rnd: obj.rnd, found: obj.found, email: obj.email, age: obj.age, gender: obj.gender, givenNames: obj.givenNames, surname: obj.surname, fullname: obj.fullname, address: obj.address, dateOfBirth: obj.dateOfBirth, personalNumber: obj.personalNumber, citizenship: obj.citizenship, nationality: obj.nationality, docCountry: obj.docCountry, docEdition: obj.docEdition, docType: obj.docType, docIssue: obj.docIssue, docExpiry: obj.docExpiry, docNumber: obj.docNumber, banned: obj.banned, bannedListed: obj.bannedListed, faceUrl: obj.faceUrl};
    setVisitor(visData);
    postVisitor(obj.final, visData);
  };

  const onOnboardAccept = () => {
    setStep(Step.ONBOARD_TIPS);
  };

  const onOnboardTips = () => {
    setStep(Step.ONBOARD_SCAN_FRONT_ID);
  };

  const onOnboardTurn = () => {
    setStep(Step.ONBOARD_SCAN_BACK_ID);
  };

  const onOnboardFrontDoc: DocumentCallback = async (imageData, content) => {
    const data = new FormData();
	  data.append("step", String(Step.ONBOARD_SCAN_FRONT_ID));
    data.append("email", visitor.email);
    data.append("lang", visitor.id_lang.toString());
	  data.append("data", imageData.image);
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerOnboardFrontRecieve, onServerOnboardFrontFail);
  };

  const onOnboardFrontDocError = (error: Error) => {
    showError({header: getLang(LangIds.MAIN_Capture, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum1, visitor.id_lang), msgTop: error.message, msgBottom: '', nextStep: Step.ONBOARD_SCAN_FRONT_ID});
  };

  const onServerOnboardFrontRecieve = (obj: any) => {
    if(checkStatus(obj))
      return;

    setOnboarding({tmp: obj.tmp, sec: obj.sec});

    if(obj.status === 1)
      onServerOnboardRecieve(obj);
    else
      setStep(Step.ONBOARD_TURN_DOC);
  };

  const onServerOnboardFrontFail = (msg: string, msgExt: string) => {
    showError({header: getLang(LangIds.MAIN_Capture, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum1, visitor.id_lang), msgTop: msg, msgBottom: msgExt, nextStep: Step.ONBOARD_SCAN_FRONT_ID});
  }

  const onOnboardBackDoc: DocumentCallback = async (imageData, content) => {
    const data = new FormData();
	  data.append("step", String(Step.ONBOARD_SCAN_BACK_ID));
    data.append("tmp", String(onboarding.tmp));
    data.append("sec", String(onboarding.sec));
	  data.append("data", imageData.image);
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerOnboardRecieve, onServerOnboardBackFail);
  };

  const onOnboardBackDocError = (error: Error) => {
    showError({header: getLang(LangIds.MAIN_Capture, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum1, visitor.id_lang), msgTop: error.message, msgBottom: '', nextStep: Step.ONBOARD_SCAN_BACK_ID});
  };

  const onServerOnboardBackFail = (msg: string, msgExt: string) => {
    showError({header: getLang(LangIds.MAIN_Capture, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum1, visitor.id_lang), msgTop: msg, msgBottom: msgExt, nextStep: Step.ONBOARD_SCAN_BACK_ID});
  };

  const onOnboardFace: FaceCallback = async (imageData, content) => {
    setStep(Step.ONBOARD_PROCESSING);
    const data = new FormData();
	  data.append("step", String(Step.ONBOARD_SCAN_FACE));
    data.append("tmp", String(onboarding.tmp));
    data.append("sec", String(onboarding.sec));
	  data.append("data", imageData.image);
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerOnboardFaceRecieve, onServerOnboardFaceFail);
  };
  
  const onOnboardFaceError = (error: Error) => {
    showError({header: getLang(LangIds.MAIN_Selfie, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum3, visitor.id_lang), msgTop: error.message, msgBottom: '', nextStep: Step.ONBOARD_SCAN_FACE});
  };

  const onFaceonlyFace: FaceCallback = async (imageData, content) => {
    setStep(Step.FACEONLY_PROCESSING);
    const data = new FormData();
	  data.append("step", String(Step.FACEONLY_SCAN_FACE));
    data.append("email", visitor.email);
	  data.append("data", imageData.image);
    data.append("lang", String(visitor.id_lang));
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerFaceonlyFaceRecieve, onServerFaceonlyFaceFail);
  };

  const onServerFaceonlyFaceRecieve = (obj: any) => {
    visitor.id = obj.id;
    visitor.customId = obj.customId;
    visitor.faceUrl = obj.faceUrl;
    visitor.email = obj.email;
    visitor.age = obj.age;
    visitor.gender = obj.gender;
    visitor.bannedListed = obj.bannedListed;
    visitor.banned = obj.banned;
    postVisitor(obj.final, visitor);
  };

  const onServerFaceonlyFaceFail = (msg: string, msgExt: string) => {
    showError({header: getLang(LangIds.MAIN_Selfie, visitor.id_lang), headerNum: '', msgTop: msg, msgBottom: msgExt, nextStep: Step.FACEONLY_SCAN_FACE});
  };

  const onFaceonlyFaceError = (error: Error) => {
    showError({header: getLang(LangIds.MAIN_Selfie, visitor.id_lang), headerNum: '', msgTop: error.message, msgBottom: '', nextStep: Step.FACEONLY_SCAN_FACE});
  };

  const onServerOnboardRecieve = (obj: any) => {
    if(checkStatus(obj))
      return;

    setVisConfig({cfgEmail: obj.cfgEmail, cfgAge: obj.cfgAge, cfgGender: obj.cfgGender, cfgGivenNames: obj.cfgGivenNames, cfgSurname: obj.cfgSurname, cfgFullname: obj.cfgFullname, cfgAddress: obj.cfgAddress, cfgDateOfBirth: obj.cfgDateOfBirth, cfgPersonalNumber: obj.cfgPersonalNumber, cfgCitizenship: obj.cfgCitizenship, cfgNationality: obj.cfgNationality, cfgDocCountry: obj.cfgDocCountry, cfgDocEdition: obj.cfgDocEdition, cfgDocType: obj.cfgDocType, cfgDocIssue: obj.cfgDocIssue, cfgDocExpiry: obj.cfgDocExpiry, cfgDocNumber: obj.cfgDocNumber});
    visitor.customId = obj.customId;
    visitor.email = obj.email;
    visitor.age = obj.age;
    visitor.gender = obj.gender;
    visitor.givenNames = obj.givenNames;
    visitor.surname = obj.surname;
    visitor.fullname = obj.fullname;
    visitor.address = obj.address;
    visitor.dateOfBirth = obj.dateOfBirth;
    visitor.personalNumber = obj.personalNumber;
    visitor.citizenship = obj.citizenship;
    visitor.nationality = obj.nationality;
    visitor.docCountry = obj.docCountry;
    visitor.docEdition = obj.docEdition;
    visitor.docType = obj.docType;
    visitor.docIssue = obj.docIssue;
    visitor.docExpiry = obj.docExpiry;
    visitor.docNumber = obj.docNumber;
    setStep(Step.ONBOARD_SUMMARY);
  };

  const onServerOnboardFaceRecieve = (obj: any) => {
    visitor.id = obj.id;
    visitor.customId = obj.customId;
    visitor.faceUrl = obj.faceUrl;
    visitor.bannedListed = obj.bannedListed;
    visitor.banned = obj.banned;
    postVisitor(obj.final, visitor);
  };

  const onServerOnboardFaceFail = (msg: string, msgExt: string) => {
    showError({header: getLang(LangIds.MAIN_Selfie, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum3, visitor.id_lang), msgTop: msg, msgBottom: msgExt, nextStep: Step.ONBOARD_SCAN_FACE});
  };

  const onRetake = () => {
    setStep(errorScr.nextStep);
  };

  const onOnboardSelfie = () => {
    setStep(Step.ONBOARD_SCAN_FACE);
  };

  const onFaceonlySelfie = () => {
    setStep(Step.FACEONLY_SCAN_FACE);
  };

  const onSumRetake = () => {
    // eslint-disable-next-line no-restricted-globals
    if(confirm(getLang(LangIds.MAIN_Retake, visitor.id_lang))){
      setStep(Step.ONBOARD_SCAN_FRONT_ID);
    }
  };

  const onSumConfirm = (visitor: VisitorData) => {
    const data = new FormData();
	  data.append("step", String(Step.ONBOARD_SUMMARY));
    data.append("tmp", String(onboarding.tmp));
    data.append("sec", String(onboarding.sec));
    data.append("email", String(visitor.email));
    data.append("age", String(visitor.age));
    data.append("gender", String(visitor.gender));
    data.append("givenNames", String(visitor.givenNames));
    data.append("surname", String(visitor.surname));
    data.append("fullname", String(visitor.fullname));
    data.append("address", String(visitor.address));
    data.append("dateOfBirth", String(visitor.dateOfBirth));
    data.append("personalNumber", String(visitor.personalNumber));
    data.append("citizenship", String(visitor.citizenship));
    data.append("nationality", String(visitor.nationality));
    data.append("docCountry", String(visitor.docCountry));
    data.append("docEdition", String(visitor.docEdition));
    data.append("docType", String(visitor.docType));
    data.append("docIssue", String(visitor.docIssue));
    data.append("docExpiry", String(visitor.docExpiry));
    data.append("docNumber", String(visitor.docNumber));
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerConfirmRecieve, onServerConfirmFail);
  };

  const onServerConfirmRecieve = (obj: any) => {
    if(checkStatus(obj))
      return;
  
    setStep(Step.ONBOARD_SELFIE);
  };

  const onServerConfirmFail = (msg: string, msgExt: string) => {
    showError({header: getLang(LangIds.MAIN_Review, visitor.id_lang), headerNum: getLang(LangIds.MAIN_HeaderNum2, visitor.id_lang), msgTop: msg, msgBottom: msgExt, nextStep: Step.ONBOARD_SCAN_FRONT_ID});
  };
  
  const setCSSVariable = (element:any, variable:any, value:any) => {
    if(value !== undefined)
      element.style.setProperty(variable, value);
  }

  const initWeb = () =>{
    if(urlColors === null || urlColors === "0" || initSent)
      return;

    setInitSent(true);
    const data = new FormData();
	  data.append("step", String(Step.WEB_CONFIG));
    ServerSend(data, visitor.id_lang, sessionId, onServerFinish, onServerWebConfigRecieve, onServerWebConfigFail);
  }

  const onServerWebConfigRecieve = (obj: any) => {
    if(checkStatus(obj))
      return;

    setCSSVariable(document.documentElement, "--colorScheme", obj.colorScheme);
    setCSSVariable(document.documentElement, "--backgroundColor", obj.backgroundColor);
    setCSSVariable(document.documentElement, "--bigTextColor", obj.bigTextColor);
    setCSSVariable(document.documentElement, "--mediumTextColor", obj.mediumTextColor);
    setCSSVariable(document.documentElement, "--smallTextColor", obj.smallTextColor);
    setCSSVariable(document.documentElement, "--cameraTextColor", obj.cameraTextColor);
    setCSSVariable(document.documentElement, "--labelTextColor", obj.labelTextColor);
    setCSSVariable(document.documentElement, "--linkTextColor", obj.linkTextColor);
    setCSSVariable(document.documentElement, "--checkSeletedBackgroundColor", obj.checkSeletedBackgroundColor);
    setCSSVariable(document.documentElement, "--checkSeletedCheckColor", obj.checkSeletedCheckColor);
    setCSSVariable(document.documentElement, "--checkBackgroundColor", obj.checkBackgroundColor);
    setCSSVariable(document.documentElement, "--checkBorderColor", obj.checkBorderColor);
    setCSSVariable(document.documentElement, "--checkHighlightedBackgroundColor", obj.checkHighlightedBackgroundColor);
    setCSSVariable(document.documentElement, "--checkHighlightedBorderColor", obj.checkHighlightedBorderColor);
    setCSSVariable(document.documentElement, "--headerBackgroundColor", obj.headerBackgroundColor);
    setCSSVariable(document.documentElement, "--headerIconColor", obj.headerIconColor);
    setCSSVariable(document.documentElement, "--headerTextColor", obj.headerTextColor);
    setCSSVariable(document.documentElement, "--headerPagesColor", obj.headerPagesColor);
    setCSSVariable(document.documentElement, "--inputBackgroundColor", obj.inputBackgroundColor);
    setCSSVariable(document.documentElement, "--inputBorderColor", obj.inputBorderColor);
    setCSSVariable(document.documentElement, "--inputTextColor", obj.inputTextColor);
    setCSSVariable(document.documentElement, "--inputHighlightedBackgroundColor", obj.inputHighlightedBackgroundColor);
    setCSSVariable(document.documentElement, "--inputHighlightedBorderColor", obj.inputHighlightedBorderColor);
    setCSSVariable(document.documentElement, "--inputHighlightedTextColor", obj.inputHighlightedTextColor);
    setCSSVariable(document.documentElement, "--buttonBackgroundColor", obj.buttonBackgroundColor);
    setCSSVariable(document.documentElement, "--buttonTextColor", obj.buttonTextColor);
    setCSSVariable(document.documentElement, "--blankButtonBackgroundColor", obj.blankButtonBackgroundColor);
    setCSSVariable(document.documentElement, "--blankButtonBorderColor", obj.blankButtonBorderColor);
    setCSSVariable(document.documentElement, "--blankButtonTextColor", obj.blankButtonTextColor);
    setCSSVariable(document.documentElement, "--errorTextColor", obj.errorTextColor);
    setCSSVariable(document.documentElement, "--errorIconColor", obj.errorIconColor);
    setCSSVariable(document.documentElement, "--backgroundColorDark", obj.backgroundColorDark);
    setCSSVariable(document.documentElement, "--bigTextColorDark", obj.bigTextColorDark);
    setCSSVariable(document.documentElement, "--mediumTextColorDark", obj.mediumTextColorDark);
    setCSSVariable(document.documentElement, "--smallTextColorDark", obj.smallTextColorDark);
    setCSSVariable(document.documentElement, "--cameraTextColorDark", obj.cameraTextColorDark);
    setCSSVariable(document.documentElement, "--labelTextColorDark", obj.labelTextColorDark);
    setCSSVariable(document.documentElement, "--linkTextColorDark", obj.linkTextColorDark);
    setCSSVariable(document.documentElement, "--checkSeletedBackgroundColorDark", obj.checkSeletedBackgroundColorDark);
    setCSSVariable(document.documentElement, "--checkSeletedCheckColorDark", obj.checkSeletedCheckColorDark);
    setCSSVariable(document.documentElement, "--checkBackgroundColorDark", obj.checkBackgroundColorDark);
    setCSSVariable(document.documentElement, "--checkBorderColorDark", obj.checkBorderColorDark);
    setCSSVariable(document.documentElement, "--checkHighlightedBackgroundColorDark", obj.checkHighlightedBackgroundColorDark);
    setCSSVariable(document.documentElement, "--checkHighlightedBorderColorDark", obj.checkHighlightedBorderColorDark);
    setCSSVariable(document.documentElement, "--headerBackgroundColorDark", obj.headerBackgroundColorDark);
    setCSSVariable(document.documentElement, "--headerIconColorDark", obj.headerIconColorDark);
    setCSSVariable(document.documentElement, "--headerTextColorDark", obj.headerTextColorDark);
    setCSSVariable(document.documentElement, "--headerPagesColorDark", obj.headerPagesColorDark);
    setCSSVariable(document.documentElement, "--inputBackgroundColorDark", obj.inputBackgroundColorDark);
    setCSSVariable(document.documentElement, "--inputBorderColorDark", obj.inputBorderColorDark);
    setCSSVariable(document.documentElement, "--inputTextColorDark", obj.inputTextColorDark);
    setCSSVariable(document.documentElement, "--inputHighlightedBackgroundColorDark", obj.inputHighlightedBackgroundColorDark);
    setCSSVariable(document.documentElement, "--inputHighlightedBorderColorDark", obj.inputHighlightedBorderColorDark);
    setCSSVariable(document.documentElement, "--inputHighlightedTextColorDark", obj.inputHighlightedTextColorDark);
    setCSSVariable(document.documentElement, "--buttonBackgroundColorDark", obj.buttonBackgroundColorDark);
    setCSSVariable(document.documentElement, "--buttonTextColorDark", obj.buttonTextColorDark);
    setCSSVariable(document.documentElement, "--blankButtonBackgroundColorDark", obj.blankButtonBackgroundColorDark);
    setCSSVariable(document.documentElement, "--blankButtonBorderColorDark", obj.blankButtonBorderColorDark);
    setCSSVariable(document.documentElement, "--blankButtonTextColorDark", obj.blankButtonTextColorDark);
    setCSSVariable(document.documentElement, "--errorTextColorDark", obj.errorTextColorDark);
    setCSSVariable(document.documentElement, "--errorIconColorDark", obj.errorIconColorDark);
    setCSSVariable(document.documentElement, "--cameraTextFont", obj.cameraTextFont);
    setCSSVariable(document.documentElement, "--bigTextFont", obj.bigTextFont);
    setCSSVariable(document.documentElement, "--mediumTextFont", obj.mediumTextFont);
    setCSSVariable(document.documentElement, "--smallTextFont", obj.smallTextFont);
    setCSSVariable(document.documentElement, "--labelFont", obj.labelFont);
    setCSSVariable(document.documentElement, "--linkFont", obj.linkFont);
    setCSSVariable(document.documentElement, "--headerPagesFont", obj.headerPagesFont);
    setCSSVariable(document.documentElement, "--headerTextFont", obj.headerTextFont);
    setCSSVariable(document.documentElement, "--inputFont", obj.inputFont);
    setCSSVariable(document.documentElement, "--inputHighlightedFont", obj.inputHighlightedFont);
    setCSSVariable(document.documentElement, "--buttonFont", obj.buttonFont);
    setCSSVariable(document.documentElement, "--blankButtonFont", obj.blankButtonFont);
    setCSSVariable(document.documentElement, "--errorFont", obj.errorFont);
  };

  const onServerWebConfigFail = (msg: string, msgExt: string) => {
    alert(msg + msgExt);
  }
  
  initWeb();

  const renderStep = (currentStep: Step) => {
    switch (currentStep) {
      case Step.ONBOARD_ACCEPT_TERMS:
        return <AcceptTerms lang={visitor.id_lang} onAccept={onOnboardAccept} />;

      case Step.ONBOARD_TIPS:
        return <Tips lang={visitor.id_lang} onAccept={onOnboardTips} />;

      case Step.ONBOARD_SCAN_FRONT_ID:
        return <DocumentScanFront lang={visitor.id_lang} headerNum={getLang(LangIds.MAIN_HeaderNum1, visitor.id_lang)} onDocument={onOnboardFrontDoc} onError={onOnboardFrontDocError} />;

      case Step.ONBOARD_TURN_DOC:
        return <TurnDoc lang={visitor.id_lang} onAccept={onOnboardTurn} />;

      case Step.ONBOARD_SCAN_BACK_ID:
        return <DocumentScanBack lang={visitor.id_lang} headerNum={getLang(LangIds.MAIN_HeaderNum1, visitor.id_lang)} onDocument={onOnboardBackDoc} onError={onOnboardBackDocError} />;

      case Step.ONBOARD_SUMMARY:
        return <Summary lang={visitor.id_lang} visitor={visitor} cfg={visConfig} onRetake={onSumRetake} onConfirm={onSumConfirm} />;

      case Step.ONBOARD_SELFIE:
        return <Selfie lang={visitor.id_lang} headerNum={getLang(LangIds.SELFIE_Headnum, visitor.id_lang)} onClick={onOnboardSelfie}/>;

      case Step.ONBOARD_SCAN_FACE:
        return <FaceScan lang={visitor.id_lang} headerNum={getLang(LangIds.MAIN_HeaderNum3, visitor.id_lang)} onFace={onOnboardFace} onError={onOnboardFaceError} />;

      case Step.ONBOARD_PROCESSING:
          return <Processing lang={visitor.id_lang} headerNum={getLang(LangIds.MAIN_HeaderNum4, visitor.id_lang)}/>;

      case Step.VISITOR_INFO:
        return <FaceScan lang={visitor.id_lang} headerNum={''} onFace={onVisitorFace} onError={onVisitorError} />;

      case Step.VISITOR_PROCESSING:
        return <Processing lang={visitor.id_lang} headerNum={''}/>;

      case Step.FACEONLY_SELFIE:
        return <SelfieFaceOnly lang={visitor.id_lang} headerNum={''} onClick={onFaceonlySelfie}/>;

      case Step.FACEONLY_SCAN_FACE:
        return <FaceScan lang={visitor.id_lang} headerNum={''} onFace={onFaceonlyFace} onError={onFaceonlyFaceError} />;

      case Step.FACEONLY_PROCESSING:
        return <Processing lang={visitor.id_lang} headerNum={''}/>;

      case Step.SHOW_ERROR:
      default:
        return <ErrorMsg lang={visitor.id_lang} headerText={errorScr.header} headerNum={errorScr.headerNum} msgTop={errorScr.msgTop} msgBottom={errorScr.msgBottom} onRetake={onRetake} />;
    }
  };
  
  return renderStep(step);
}

export default App;
